import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../api-base/api.service';
import { CollectionResponse, Industry } from '@libs/types';

@Injectable()
export class IndustriesApiService extends ApiService {
  private readonly industriesUrl = '/edge/reference-data/industries';

  constructor(private http: HttpClient) {
    super();
  }

  getIndustries(): Observable<CollectionResponse<Industry>> {
    return this.http.get<CollectionResponse<Industry>>(this.industriesUrl);
  }
}
